import { Card, CardContent } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import { Box, Typography } from '@mui/material'
import defaultMachineThumb from '../../assets/img/default-machine.png'
import { useDateFormatter } from '../../hooks/useDateFormatter'
import ActionsMenu from '../ActionsMenu/ActionsMenu'

interface Props {
  machine: Machine
  setMachineToEdit: (machine: Machine) => void
  setShowAddEditMachine: (show: boolean) => void
  setShowDeleteModal: (show: boolean) => void
  setMachineToDelete: (machine: Machine) => void
}

const MachineCard = ({
  machine,
  setMachineToEdit,
  setShowAddEditMachine,
  setShowDeleteModal,
  setMachineToDelete,
}: Props) => {
  const handleEditMachine = () => {
    setMachineToEdit(machine)
    setShowAddEditMachine(true)
  }

  const handleDeleteMachine = () => {
    setShowDeleteModal(true)
    setMachineToDelete(machine)
  }

  return (
    <div className={`card-wrapper machine`}>
      <Card className={`white-card`}>
        <Box
          className={`thumbnail-container ${
            !machine.thumbnail.id && 'no-thumbnail'
          }`}
          sx={{
            backgroundImage: machine.thumbnail.id
              ? `url(${process.env.REACT_APP_API}/api/thumbnail/${machine.thumbnail.id})`
              : `url(${defaultMachineThumb})`,
          }}
        />

        <CardContent>
          <div className="content">
            <div className="flex align-center">
              <h4 className="m-b-0">{machine.name}</h4>
              <ActionsMenu
                icon={<ArrowDropDown />}
                options={[
                  { onClick: handleEditMachine, label: 'Edit' },
                  { onClick: handleDeleteMachine, label: 'Delete' },
                ]}
              />
            </div>

            <Typography sx={{ minHeight: 20 }}>{machine.model}</Typography>

            <div className="flex space-between last-updated">
              <p>
                <strong className="primary">Last updated:</strong>
              </p>
              <p>{useDateFormatter(machine.updatedAt)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default MachineCard
